<!-- AddNewProduct.vue -->
<template>
  <simple-layout>
    <AddNewProductComp />
  </simple-layout>
</template>

<script>
import AddNewProductComp from '@/components/add-product/AddNewProductComp.vue';
import SimpleLayout from '@/layouts/SimpleLayout.vue';

export default {
  components: {
    SimpleLayout,
    AddNewProductComp
  },
};
</script>

